// extracted by mini-css-extract-plugin
module.exports = {"footer__form":"ResidentUpdate_footer__form__Wja-D","btn__footer":"ResidentUpdate_btn__footer__1HZR3","text__default":"ResidentUpdate_text__default__mmzzi"};